export default "__VITE_ASSET__BnU8Lg0o__"